import React, { useState } from 'react'
import { Modal } from 'antd'
import 'styleLess/signature/textSeemore.scss'

const TextSeeMore = ({ text, titleModal }) => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  return (
    <>
      <Modal
        visible={isOpenModal}
        onCancel={() => setIsOpenModal(false)}
        centered
        footer={false}
      >
        <div className='font-header'>{titleModal}</div>
        <p className='font-lable'>{text}</p>
      </Modal>
      <span className='small text-container'>
        {text.slice(0, 50)}
        {text.length > 50 && (
          <button className='see-more-button' onClick={() => setIsOpenModal(true)}>
            See more
          </button>
        )}
      </span>
    </>
  )
}

export default TextSeeMore
